import {Component, inject, signal} from '@angular/core';
import {Button} from 'primeng/button';
import {AuthFacade} from '../../../../auth/facade/auth.facade';
import {Menu} from 'primeng/menu';
import {MenuItem} from 'primeng/api';
import {UserDetailsService} from '../../../../../features/users/dialogs/user-details/user-details.service';
import {UserProfileStore} from '../../../../auth/stores/user-profile.store';

@Component({
	selector: 'app-sidebar-current-user',
	imports: [
		Button,
		Menu
	],
	standalone: true,
	template: `
		<p-menu #menu
				[model]="menuItems"
				[popup]="true"
				appendTo="body"/>
		<p-button [icon]="isHover() ? 'pi pi-cog' : 'pi pi-user'"
				  [rounded]="true"
				  (mouseenter)="isHover.set(true)"
				  (mouseleave)="isHover.set(false)"
				  (onClick)="menu.toggle($event)"
				  variant="outlined"></p-button>
	`,
	styleUrl: './sidebar-current-user.css'
})
export class SidebarCurrentUser {
	private facade = inject(AuthFacade)
	private userDetailsService = inject(UserDetailsService)
	private profileStore = inject(UserProfileStore)

	currentUser = this.profileStore.currentUser
	isHover = signal(false)

	readonly menuItems: MenuItem[] = [
		{
			label: 'Impostazioni',
			icon: 'pi pi-user-edit',
			command: () => {
				const user = this.currentUser()
				if (!user) return

				this.userDetailsService.openDetailDialog(user)
			}
		},
		{
			label: 'Logout',
			icon: 'pi pi-sign-out',
			command: () => {
				this.facade.logout();
			}
		}
	];
}
